/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */

import { LocalStorageKey } from '../../../utils/local-storage-key'

export const MOTD_LOCAL_STORAGE_KEY: string = LocalStorageKey.MOTD_LAST_MODIFIED
export const IGNORE_MOTD: string = 'IGNORE_MOTD'
